export const TIME_OUT = 300

export const BACKDROP_KIND = {
  DEFAULT: 'Default',
  DARKER: 'Darker',
} as const
